import { render, staticRenderFns } from "./PermissionsModal.vue?vue&type=template&id=07b2592f&scoped=true&"
import script from "./PermissionsModal.vue?vue&type=script&lang=ts&"
export * from "./PermissionsModal.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionsModal.vue?vue&type=style&index=0&id=07b2592f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b2592f",
  null
  
)

export default component.exports